import React, { useState } from 'react';
import wave from './icons/wave.png';
import handshake from './icons/handshake.png';
import Button from '../../components/form-elements/button';
import { useNavigate } from "react-router-dom";
import Input from '../form-elements/input';
import { useAuth } from '../../hooks/useAuth';
import AppRoutes from '../../constants/AppRoutes';
import PropTypes from 'prop-types';
import AuthenticationService from '../../services/authentication-service';
import Messages from '../../constants/Messages';
import CartService from '../../services/cart-service';

const Modal = ({ visible, onClose, setSelectedValues, data, isEventTime }) => {
    const [selectedLocation, setSelectedLocation] = useState(null);
    const { authLogout } = useAuth();
    const navigate = useNavigate();

     /** ---------------------------------------------------
     * Method : logout
     * Description : To logout user from the app
     */
     const logout = async () => {
        authLogout();
        navigate(AppRoutes.LOGIN);
    }

    const getEventUpdates = async () => {
        await AuthenticationService.getEventUpdates();
        window.location.reload();
    }

    function isDisabled() {
        return selectedLocation === null;
    }

    function handleOnClose(selectedLocation) {
        AuthenticationService.setEventDetails(selectedLocation);
        setSelectedValues({selectedLocation})
        onClose();
    }

    function onEventEnd() {
        AuthenticationService.clearEventDetails();
        CartService.clearCart();
        onClose();
        window.location.reload();
    }

    function renderModalMsg() {
        if(isEventTime) {
            if(data.eventDetails && data?.eventDetails?.locationDetails?.name === data?.userDetails?.locationDetails?.name) return Messages.MODAL.WELCOME_MSG_SAME_LOCATION(data?.eventDetails?.locationDetails?.name);
            else if(!data.eventDetails) return Messages.MODAL.INTIMATE_LOGOUT_FOR_EVENT_START;
            else return Messages.MODAL.WELCOME_MSG_DIFF_LOCATION(data.eventDetails?.locationDetails?.name);
        } else {
            return Messages.MODAL.THANKS_MSG;
        }
    } 

    if (!visible) return null;
    else return (<div className='fixed inset-0 z-20 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center'>
        <div className="bg-white py-6 px-5 rounded w-max flex items-center justify-center flex-col gap-5 rounded-3xl">
            <div className='flex gap-4 justify-center items-center'>
                <img src={isEventTime ? wave : handshake} className='h-8'></img>
            </div>
            <h1 className='text-xl font-black'>{Messages.MODAL.GREET} {data.userDetails.name}!</h1>
            <p className='text-center w-80'>{renderModalMsg()}</p>
           { isEventTime && data?.eventDetails && data?.eventDetails?.locationDetails?.name !== data.userDetails.locationDetails.name ? <div className='flex gap-6'>
                <div className='flex gap-2 items-center'>
                    <Input type='radio' name='locations' value={data?.eventDetails?.locationDetails?.name} className='h-5 w-5 accent-rose-700' onChange={(e) => {setSelectedLocation(e.target.value)}} />
                    <label>{data?.eventDetails?.locationDetails?.name}</label>
                </div>
                <div className='flex gap-2  items-center'>
                    <Input type='radio' name='locations' value={data?.userDetails?.locationDetails?.name} className='h-5 w-5 accent-rose-700' onChange={(e) => {setSelectedLocation(e.target.value)}} />
                    <label>{data?.userDetails?.locationDetails?.name}</label>
                </div>
            </div> : null}
            {isEventTime ? (data?.eventDetails && data?.eventDetails?.locationDetails?.name !== data?.userDetails?.locationDetails?.name ? <div className='flex gap-4'>
                <Button size={'small'} color={'secondary'} disabled={isDisabled()} onClick={() => handleOnClose(selectedLocation)}>{Messages.MODAL.SUBMIT}</Button>
                <Button size={'small'} color={'tertiary'} onClick={logout}>{Messages.MODAL.LOGOUT}</Button>
            </div> : (!data?.eventDetails ? <Button size={'small'} color={'secondary'} onClick={getEventUpdates}>{Messages.MODAL.OKAY}</Button> : <Button size={'small'} color={'secondary'} onClick={() => handleOnClose(data?.userDetails?.locationDetails?.name)}>{Messages.MODAL.OKAY}</Button>)) : <Button size={'small'} color={'secondary'} onClick={onEventEnd}>{Messages.MODAL.OKAY}</Button>}
        </div>
    </div>);
}

Modal.propTypes = {
    visible: PropTypes.bool, 
    onClose: PropTypes.func,
    setSelectedValues: PropTypes.func,
    data: PropTypes.object,
    isEventTime: PropTypes.bool
}

export default Modal;